import FormBox from "./components/box"
import FormRow from "./components/row"
import FormGroup from "./components/group"
import FormRender from "./components/render"
import FormSection from "./components/section"
import FormCurrency from "./components/currency"
import FormContainer from "./components/container"

const Form = {
    Box: FormBox,
    Container: FormContainer,
    Section: FormSection,
    Row: FormRow,
    Group: FormGroup,
    Currency: FormCurrency,
    Render: FormRender,
}

export default Form
export {
    FormContainer, FormSection, FormRow, FormGroup, FormRender, FormBox,
}